export default __webpack_public_path__ + "static/media/contact-3.a8026d49.png";